
/* injects from baggage-loader */
var Template = require('./template.js');

import {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import { UIMixin } from "../../../mixins/uiMixin";

class TicketInManualCheck extends Component {
    constructor (props) {
        super(props);
        this.state = {};
        this.confirmBarcode = this.confirmBarcode.bind(this);
        this.onChange = this.onChange.bind(this);
    }
    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }

    confirmBarcode () {
        window.barcodeEnter(this.state.barcode);
        //let e = new Event("keypress");
        //e.which = 13;
        //window.dispatchEvent(e);
        this.setState({barcode: null});
        window.barcodeBuffer = [];
        this.props.closePopup()();
    }

    onChange (text) {
        this.setState({
            barcode: text
        });
    }
}

TicketInManualCheck.propTypes = {
    data: PropTypes.object
};

export default connect()(UIMixin({Component: TicketInManualCheck}));